'use strict'
/**
 * CP0.3 money-path characterization — amount parse/format EXTRACTED VERBATIM from AmountField.vue and
 * AgGridMethods.intlNumberFormatter. Pure, framework-free, dependency-free (Node-requirable + webpack-importable).
 * AmountField.vue and the AgGridMethods mixin now delegate here, so there is ONE implementation under test.
 */

/** Verbatim from AgGridMethods.intlNumberFormatter (displayOptions passed in rather than read off `this`). */
function intlNumberFormat (number, locale, options, displayOptions) {
  displayOptions = displayOptions || {}
  if (typeof number === 'string') number = parseFloat(number)
  if (typeof number !== 'number' && !isNaN(Number(number))) return null
  var hideDecimals = displayOptions.hideDecimals || false
  var useParentheses = displayOptions.useParenthesesForNegative || false
  if (!locale) locale = 'en-us'
  if (!options) {
    options = {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: hideDecimals ? 0 : 2,
      maximumFractionDigits: hideDecimals ? 0 : 2
    }
  }
  var result = new Intl.NumberFormat(locale, options).format(number)
  // -0 should be just 0
  if (result === '-0' || result === '-0.00') {
    result = new Intl.NumberFormat(locale, options).format(0)
  }
  // currencySign option is not working on many browsers so manually handle
  if (useParentheses && result.slice(0, 1) === '-') {
    result = '(' + result.slice(1) + ')'
  }
  return result
}

/** AmountField prettyAmount setter: normalise typed input to a plain numeric string, NaN -> '0.00'. */
function normalizeAmountInput (value) {
  return isNaN(parseFloat(value)) ? '0.00' : parseFloat(value).toString()
}

/** AmountField onBlur: the value emitted on blur — 2-decimal fixed. */
function parseAmountOnBlur (currentValue) {
  return parseFloat(currentValue).toFixed(2)
}

/** AmountField prettyAmount getter: raw string while editing, else formatted (NaN -> '0'). */
function displayAmount (value, isActive, displayOptions) {
  return isActive
    ? value.toString()
    : (isNaN(parseFloat(value)) ? '0' : intlNumberFormat(value, undefined, undefined, displayOptions))
}

module.exports = {
  intlNumberFormat: intlNumberFormat,
  normalizeAmountInput: normalizeAmountInput,
  parseAmountOnBlur: parseAmountOnBlur,
  displayAmount: displayAmount
}
